import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Area, AreaChart } from 'recharts';
import { formatCurrency } from '@/lib/utils';

export default function RevenueChart({ data, title = 'Revenue vs Collections' }) {
  const chartData = data?.map(item => ({
    date: item.date?.slice(5) || item.name, // Show MM-DD
    revenue: item.revenue || 0,
    collections: item.collections || 0,
  })) || [];

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white border border-[#E2E8F0] rounded-lg p-3 shadow-lg">
          <p className="text-xs text-[#64748B] mb-2">{label}</p>
          {payload.map((entry, index) => (
            <p key={index} className="text-sm" style={{ color: entry.color }}>
              {entry.name}: {formatCurrency(entry.value)}
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="chart-container" data-testid="revenue-chart">
      <h3 className="chart-title">{title}</h3>
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={chartData}>
            <defs>
              <linearGradient id="revenueGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#0F4C81" stopOpacity={0.3}/>
                <stop offset="95%" stopColor="#0F4C81" stopOpacity={0}/>
              </linearGradient>
              <linearGradient id="collectionsGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#BFDBFE" stopOpacity={0.3}/>
                <stop offset="95%" stopColor="#BFDBFE" stopOpacity={0}/>
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" />
            <XAxis 
              dataKey="date" 
              tick={{ fontSize: 11, fill: '#64748B' }}
              axisLine={{ stroke: '#E2E8F0' }}
              tickLine={false}
            />
            <YAxis 
              tick={{ fontSize: 11, fill: '#64748B' }}
              axisLine={{ stroke: '#E2E8F0' }}
              tickLine={false}
              tickFormatter={(value) => `₹${(value / 1000).toFixed(0)}k`}
            />
            <Tooltip content={<CustomTooltip />} />
            <Area 
              type="monotone" 
              dataKey="revenue" 
              stroke="#0F4C81" 
              strokeWidth={2}
              fill="url(#revenueGradient)"
              name="Revenue"
            />
            <Area 
              type="monotone" 
              dataKey="collections" 
              stroke="#BFDBFE" 
              strokeWidth={2}
              fill="url(#collectionsGradient)"
              name="Collections"
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
      <div className="flex items-center justify-center gap-6 mt-4">
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 rounded-full bg-[#0F4C81]"></div>
          <span className="text-xs text-[#64748B]">Revenue</span>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-3 h-3 rounded-full bg-[#BFDBFE]"></div>
          <span className="text-xs text-[#64748B]">Collections</span>
        </div>
      </div>
    </div>
  );
}
